import { useDispatch, useSelector } from "react-redux";
import { OrangeButton } from "../general/OrangeButton";
import { INSURER, LOCATION } from "../store/businesslogic/hardwiredlogic";
import { getQFuserMode } from "../store/components";
import {
  addLocationToFormThunk,
  getAddButtonText,
  getNode,
  updateAddressParts,
} from "../store/qf";
import * as theme from "../theme";
import MinusIcon from "./MinusIcon";
import PlusIcon from "./PlusIcon";
import FormCompleteIcon from "../general/FormCompleteIcon";
import { useEffect } from "react";
import translations from "../utils/translations";
import { getBrokerInformation } from "../store/broker";

const FormNavHeader = ({
  text,
  formtype,
  isopen,
  isFormExpandable,
  formid,
  handleOnClick,
  display = "flex",
}) => {
  const dispatch = useDispatch();
  const qfusermode = useSelector(getQFuserMode);
  return (
    <div
      id={`formtype_${formtype}_${formid}`}
      style={{
        height: theme.SCALES.qfNavTabHeaderHeight,
        display: display,
        alignItems: "center",
        width: "100%",
        backgroundColor: isopen
          ? theme.COLORS.navigation_header_tab
          : theme.COLORS.primary_navyblue,
        paddingLeft: "11%",
        paddingRight: "8%",
        fontWeight: isopen ? "Bold" : "",
        letterSpacing: 1.2,
        justifyContent: "space-between",
        fontSize: "1.9vmin",
      }}
      onClick={handleOnClick}
    >
      <div>
        <div>
          {`${text} `}
          <FormCompleteIcon formid={formid}></FormCompleteIcon>
        </div>
      </div>
      {formtype === LOCATION ? (
        <AddButton
          isopen={isopen}
          qfusermode={qfusermode}
          formid={formid}
        ></AddButton>
      ) : null}
      {isFormExpandable ? (
        <div>{isopen ? <MinusIcon></MinusIcon> : <PlusIcon></PlusIcon>}</div>
      ) : null}
    </div>
  );
};
// This are the constants that should be coming from the json file
// TODO: change this hardcoded things in the json files.

const LOCATION_ADDRESS_DEPENDS_ON = {
  q10505: {
    questionid: "10505",
    // groupid: "b_105",
    formid: "a",
  },
  q68497: {
    questionid: "68497",
    // groupid: "b_108",
    formid: "a_2",
  },
};

function AddButton({ isopen, qfusermode, formid }) {
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference || "en";

  const addButtonText = useSelector(getAddButtonText({ formid }));

  const q10505 = useSelector(
    getNode({ ...LOCATION_ADDRESS_DEPENDS_ON.q10505 })
  );
  const q68497 = useSelector(
    getNode({ ...LOCATION_ADDRESS_DEPENDS_ON.q68497 })
  );

  const decideAddButtonText = ({ addButtonText }) => {
    if (addButtonText) {
      return addButtonText;
    }

    return translations[languagepreference].addLocation;
  };

  useEffect(() => {
    // dispatch
    dispatch(updateAddressParts({ formid }));
  }, [q10505?.answer, q68497?.answer]);
  return (
    <OrangeButton
      disable={isopen ? (qfusermode === INSURER ? true : false) : true}
      text={decideAddButtonText({ addButtonText })}
      onClick={(e) => {
        e.stopPropagation();
        dispatch(addLocationToFormThunk({ formid }));
      }}
      width={"6vmin"}
    ></OrangeButton>
  );
}

export default FormNavHeader;
